let lastActivityAt = Date.now()
let listenersAttached = false

const EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'scroll',
  'touchstart',
  'click'
]

export function markUserActivity() {
  lastActivityAt = Date.now()
  console.debug('[Activity] marcado:', new Date(lastActivityAt).toLocaleTimeString())
}

export function getLastActivityAt() {
  return lastActivityAt
}

export function hasRecentActivity(withinMs = 2 * 60 * 1000) {
  return Date.now() - lastActivityAt <= withinMs
}

export function attachActivityListeners() {
  if (listenersAttached || typeof window === 'undefined') return
  listenersAttached = true

  EVENTS.forEach((eventName) => {
    window.addEventListener(eventName, markUserActivity, { passive: true })
  })
}